<template>
  <div class="i-three-keys">
    <div
      class="header"
      v-html="COPY_DATA[testTakingPurposeKey].h2"
    ></div>
    <div class="cards">
      <div
        v-for="(data, index) in cardData"
        :key="index"
        class="card"
        :class="`v${index}`"
      >
        <div class="top">{{ data.top }}</div>
        <div class="bottom">{{ data.bottom }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { useReportStore } from "@/stores/report"

import { COPY_DATA } from "@/helpers/startPageDynamicData"

// STORES
const reportStore = useReportStore()

// COMPUTED
const testTakingPurposeKey = computed(() => {
  return (reportStore.getTestTakingPurpose?.id || "other") as keyof typeof COPY_DATA
})
const cardData = computed(() => {
  return [
    {
      top: COPY_DATA[testTakingPurposeKey.value].card1[0],
      bottom: COPY_DATA[testTakingPurposeKey.value].card1[1]
    },
    {
      top: COPY_DATA[testTakingPurposeKey.value].card2[0],
      bottom: COPY_DATA[testTakingPurposeKey.value].card2[1]
    },
    {
      top: COPY_DATA[testTakingPurposeKey.value].card3[0],
      bottom: COPY_DATA[testTakingPurposeKey.value].card3[1]
    }
  ]
})
</script>

<style scoped lang="scss">
.i-three-keys {
  padding: 20px 16px 0;
  margin-bottom: 50px;

  .header {
    @include display-sm;

    margin-bottom: 40px;
    font-weight: 700;
    text-align: center;

    @media screen and (min-width: $breakpoint-sm) {
      font-size: 40px;
      line-height: 50px;
    }
  }

  .cards {
    @include grid($cols: 1fr, $rows: auto, $align-items: center, $gap: 15px);

    @media screen and (min-width: $breakpoint-md) {
      gap: 25px;
      grid-template-columns: 1fr 1fr;
    }

    @media screen and (min-width: $breakpoint-lg) {
      gap: 10px;
      grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: $breakpoint-xl) {
      gap: 25px;
    }

    .card {
      @include flex(column, space-between, start);
      @include border-radius-lg;

      height: 452px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      color: white;
      padding: 30px 20px;
      margin: auto;

      &.v0 {
        background-image: url("@/assets/welcome/start-key-1.png");
      }

      &.v1 {
        background-image: url("@/assets/welcome/start-key-2.png");
      }

      &.v2 {
        background-image: url("@/assets/welcome/start-key-3.png");

        @media screen and (min-width: $breakpoint-md) {
          grid-column: 1 / 3;
        }

        @media screen and (min-width: $breakpoint-lg) {
          grid-column-start: unset;
          grid-column-end: unset;
        }
      }

      .top {
        @include display-xs;

        font-weight: 700;
      }

      .bottom {
        @include text-xl;

        font-weight: 500;
      }
    }
  }
}
</style>
